import { useEffect } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { ANALYTICS_PREFIX } from "../../common/constants";
import { PageBoardColumnsProps } from "../../common/types";
import { LeftHandSideWrapper } from "../../common/ui/left-hand-side-wrapper/left-hand-side-wrapper";
import { RightHandSideWrapper } from "../../common/ui/right-hand-side-wrapper/right-hand-side-wrapper";
import { useWizardConfiguration } from "../../controllers";

import { LeftHandSidePageBoardColumns } from "./left-hand-side/left-hand-side";
import { RightHandSidePageBoardColumns } from "./right-hand-side/right-hand-side";

export const PageBoardColumns = ({
    projectName,
    onClickNext,
    columnNames,
    setColumnNames
}: PageBoardColumnsProps) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const {
        teamType,
        projectDetails: { template }
    } = useWizardConfiguration();

    useEffect(() => {
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: `${ANALYTICS_PREFIX}BoardColumns`,
            attributes: {
                teamType,
                template
            }
        }).fire();
    }, [createAnalyticsEvent, teamType, template]);

    return (
        <>
            <LeftHandSideWrapper>
                <LeftHandSidePageBoardColumns
                    onClickNext={onClickNext}
                    columnNames={columnNames}
                    setColumnNames={setColumnNames}
                />
            </LeftHandSideWrapper>
            <RightHandSideWrapper>
                <RightHandSidePageBoardColumns
                    projectName={projectName}
                    columnNames={columnNames}
                />
            </RightHandSideWrapper>
        </>
    );
};
